import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

export const login = async ({ username, password }) => {
  try {
    const response = await axiosClient.post('/api/auth/login', {
      username,
      password,
    });

    return unwrapApiResponse(response);
  } catch (error) {
    if (error.response?.data) {
      const body = error.response.data;
      const apiError = new Error(body.message || 'Login failed');
      apiError.errors = body.errors || [];
      apiError.status = error.response.status;
      throw apiError;
    }

    throw error;
  }
};
